// assets/babylist-variant-handler.js
// Handles variant changes for Babylist button

(function() {
  'use strict';
  
  function initBabylistVariantHandler() {
    const babylistButton = document.getElementById('babylist-button');
    if (!babylistButton) return;
    
    // Get product data from window.WYATT
    const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0]?.split('#')[0];
    if (!productHandle) return;
    
    let productData = null;
    if (window.WYATT && window.WYATT.shopify) {
      if (window.WYATT.shopify.products && window.WYATT.shopify.products[productHandle]) {
        productData = window.WYATT.shopify.products[productHandle];
      } else if (window.WYATT.shopify.product && window.WYATT.shopify.product[productHandle]) {
        productData = window.WYATT.shopify.product[productHandle];
      }
    }
    
    if (!productData || !productData.variants) {
      console.warn('[Babylist] Product data not found');
      return;
    }
    
    // Function to update button
    function updateBabylistButton(variant) {
      if (!variant || !babylistButton) return;
      
      // Get variant image or fallback to product image
      let image = '';
      if (variant.featured_image && variant.featured_image.src) {
        image = variant.featured_image.src;
      } else if (variant.image) {
        image = typeof variant.image === 'string' ? variant.image : variant.image.src || '';
      } else if (productData.featured_image && productData.featured_image.src) {
        image = productData.featured_image.src;
      }
      
      // Ensure image URL is full URL
      if (image && !image.startsWith('http')) {
        image = image.startsWith('//') ? 'https:' + image : image;
      }
      
      // Format price (Shopify prices are in cents)
      const price = variant.price ? (variant.price / 100).toFixed(2) : '0.00';
      
      // Get product title
      const title = productData.title || '';
      
      // Get variant URL or product URL
      let url = '';
      if (variant.url) {
        url = variant.url.startsWith('http') ? variant.url : window.Shopify?.shop || window.location.origin + variant.url;
      } else if (productData.url) {
        url = productData.url.startsWith('http') ? productData.url : window.Shopify?.shop || window.location.origin + productData.url;
      }
      
      // Update button href
      const href = `javascript: bl.addToRegistry({
        images: '${image}',
        price: '${price}',
        title: '${title.replace(/'/g, "\\'")}',
        url: '${url}'
      });`;
      
      babylistButton.setAttribute('href', href);
    }
    
    // Watch for variant ID input changes
    function watchVariantInput() {
      const variantInput = document.querySelector('product-options input[name="id"], product-form input[name="id"]');
      if (!variantInput) return;
      
      // Listen for direct input changes
      variantInput.addEventListener('change', function() {
        const variantId = parseInt(this.value);
        if (variantId) {
          const variant = productData.variants.find(v => v.id === variantId || v.id.toString() === variantId.toString());
          if (variant) {
            updateBabylistButton(variant);
          }
        }
      });
      
      // Also watch for value changes via MutationObserver (for DOM replacements)
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const variantId = parseInt(variantInput.value);
            if (variantId) {
              const variant = productData.variants.find(v => v.id === variantId || v.id.toString() === variantId.toString());
              if (variant) {
                updateBabylistButton(variant);
              }
            }
          }
        });
      });
      
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
    
    // Watch for product-options component changes (DOM replacement)
    function watchProductOptions() {
      const productOptions = document.querySelector('product-options[data-product-options]');
      if (!productOptions) return;
      
      const observer = new MutationObserver(function() {
        // Re-attach listeners when DOM is replaced
        setTimeout(watchVariantInput, 100);
      });
      
      observer.observe(productOptions, {
        childList: true,
        subtree: true
      });
    }
    
    // Listen for custom variant change events
    document.addEventListener('variantChange', function(evt) {
      if (evt.detail && evt.detail.variant) {
        updateBabylistButton(evt.detail.variant);
      }
    });
    
    document.addEventListener('variant:change', function(evt) {
      if (evt.detail && evt.detail.variant) {
        updateBabylistButton(evt.detail.variant);
      }
    });
    
    // jQuery support (if theme uses jQuery)
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('variantChange', function(evt, variant) {
        if (variant) updateBabylistButton(variant);
      });
    }
    
    // Initialize watchers
    watchVariantInput();
    watchProductOptions();
    
    // Initial update with current variant
    setTimeout(function() {
      const variantInput = document.querySelector('product-options input[name="id"], product-form input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value);
        if (variantId) {
          const variant = productData.variants.find(v => v.id === variantId || v.id.toString() === variantId.toString());
          if (variant) {
            updateBabylistButton(variant);
          }
        }
      }
    }, 500);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBabylistVariantHandler);
  } else {
    initBabylistVariantHandler();
  }
  
  // Re-initialize after product-options updates the DOM
  if (window.MutationObserver) {
    const bodyObserver = new MutationObserver(function() {
      if (document.getElementById('babylist-button') && !document.getElementById('babylist-button').dataset.handlerAttached) {
        document.getElementById('babylist-button').dataset.handlerAttached = 'true';
        setTimeout(initBabylistVariantHandler, 100);
      }
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
